"use client";

import { atom, useAtomValue } from "jotai";

import { ONE_MINUTE_MS } from "#/config/time";
import { useThrottle } from "#/hooks/useThrottle";

import { marketAtom } from "../portfolio/market";
import { indexPricesAtom } from "./indexPrices";

export const marketIndexPriceAtom = atom((get) => {
  const market = get(marketAtom);
  const indexPrices = get(indexPricesAtom);

  return indexPrices[market.underlying];
});

export const useMarketIndexPrice = () => {
  const market = useAtomValue(marketAtom);
  const marketIndexPrice = useAtomValue(marketIndexPriceAtom);
  const throttledMarketIndexPrice = useThrottle(
    marketIndexPrice,
    ONE_MINUTE_MS,
    market.pair,
  );

  return { marketIndexPrice, throttledMarketIndexPrice };
};
